import React from 'react';
import TweenMax from 'gsap/TweenMax';
import 'gsap/CSSPlugin';

import InfoBox from './InfoBox';
import TranscriptBox from './TranscriptBox';

export default class Modal extends React.Component {

  state = {
    isVisible: this.props.isVisible,
    sw: window.innerWidth,
    sh: window.innerHeight
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (  prevState.isVisible !== nextProps.isVisible ||
          prevState.sw !== nextProps.sw ||
          prevState.sh !== nextProps.sh ) {
      return {
        isVisible: nextProps.isVisible,
        sw: nextProps.sw,
        sh: nextProps.sh,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState){
    if ( prevState.isVisible !== this.props.isVisible ) {
      if( this.props.isVisible ) {
        this.fadeInModal()
      } else {
        this.fadeOutModal();
      }
    }
  }

  renderModalContent = () => {
    if( this.props.type === 'info' ) {
      return <InfoBox screenHeight={this.state.sh} screenWidth={this.state.sw}/>
    }
    if( this.props.type === 'transcript' ) {
      return <TranscriptBox payload={this.props.payload} screenHeight={this.state.sh} screenWidth={this.state.sw}/>
    }
    this.fadeInModal()
    return false
  }

  fadeInModal = () => {
    TweenMax.to("#modal", 0, {transform: 'translateY(0vh)'});
    TweenMax.to("#modal", 0.5, {opacity:1});
  }

  fadeOutModal = () => {
    TweenMax.to("#modal", 0.5, {opacity:0, onComplete: this.removeModal});
  }

  removeModal = () => {
    TweenMax.to("#modal", 0, {transform: 'translateY(-100vh)'});
  }

  closeModal = () => {
    this.props.toggleModal( false )
  }

  render() {
    return (
      <div id={"modal"}>
        <div id={"close-modal-container"} onClick={this.closeModal}>
          <img className={"close-modal-icon"} src={"https://www.taakoschool.com/qa/Assets/Image/button-x.png"} alt={""}/>
        </div>
        { this.renderModalContent() }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/Modal.js